











































































import { Component, Vue, Prop } from "vue-property-decorator";
import { users } from "../../api/users/users";
@Component({
  name: "ActivityFilters",
  props: {
    filters: {
      dateFrom: "",
      dateTo: "",
      search: ""
    }
  },
  model: {
    prop: "filters",
    event: "change"
  },
  watch: {
    date: function(val) {
      this.$props.filters.dateFrom = val;
    }
  }
})
export default class ActivityFilters extends Vue {
  public loading: boolean = false;
  public activeName: string = "1";
  public userList: any[] = [];
  public visibleUsers: any[] = [];
  public date: Date = new Date();
  public async getUserList() {
    await users
      .getAllUsers(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          this.userList = JSON.parse(JSON.stringify(resp));
        });
      });
  }
  public remoteMethod(query: string) {
    console.log(this.userList);
    if (query !== "") {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.visibleUsers = this.userList.filter((item: any) =>
          item.name.toLowerCase().includes(query.toLowerCase())
        );
      }, 200);
    } else {
      this.visibleUsers = [];
    }
  }
  public async mounted() {
    await this.getUserList();
    this.$props.filters.dateFrom = new Date(
      new Date().setDate(new Date().getDate() - 10)
    );
    this.date = new Date(new Date().setDate(new Date().getDate() - 10));
  }
  public update() {
    this.$forceUpdate();
  }
}
